export default {
  home: '/',
  enterprise: '/enterprise',
  pricing: '/pricing',
  contact: '/contact',
}
